export const API = process.env.REACT_APP_BACKEND_URL;

export const STANDARD_STAGES = ['new', 'contacted', 'site_visit', 'estimating', 'proposal_sent', 'negotiation', 'won', 'lost', 'active_project'];
export const EMERGENCY_STAGES = ['new_emergency', 'contacted', 'technician_assigned', 'dispatched', 'in_progress', 'completed', 'closed'];

export const STAGE_LABELS = {
  new: 'New Lead',
  contacted: 'Contacted',
  site_visit: 'Site Visit',
  estimating: 'Estimating',
  proposal_sent: 'Proposal Sent',
  negotiation: 'Negotiation',
  won: 'Won',
  lost: 'Lost',
  active_project: 'Active Project',
  new_emergency: 'New Emergency',
  technician_assigned: 'Technician Assigned',
  dispatched: 'Dispatched',
  in_progress: 'In Progress',
  completed: 'Completed',
  closed: 'Closed',
  read: 'Read',
};

export const STAGE_COLORS = {
  new: 'bg-blue-500/20 text-blue-300 border-blue-500/40',
  contacted: 'bg-orange-500/20 text-orange-300 border-orange-500/40',
  site_visit: 'bg-cyan-500/20 text-cyan-300 border-cyan-500/40',
  estimating: 'bg-purple-500/20 text-purple-300 border-purple-500/40',
  proposal_sent: 'bg-indigo-500/20 text-indigo-300 border-indigo-500/40',
  negotiation: 'bg-amber-500/20 text-amber-300 border-amber-500/40',
  won: 'bg-green-500/20 text-green-300 border-green-500/40',
  lost: 'bg-red-500/20 text-red-300 border-red-500/40',
  active_project: 'bg-teal-500/20 text-teal-300 border-teal-500/40',
  new_emergency: 'bg-red-500/20 text-red-300 border-red-500/40',
  technician_assigned: 'bg-yellow-500/20 text-yellow-300 border-yellow-500/40',
  dispatched: 'bg-amber-500/20 text-amber-300 border-amber-500/40',
  in_progress: 'bg-blue-500/20 text-blue-300 border-blue-500/40',
  completed: 'bg-green-500/20 text-green-300 border-green-500/40',
  closed: 'bg-slate-500/20 text-slate-300 border-slate-500/40',
};

export const LEAD_SOURCES = ['Google Organic', 'Google Ads', 'Instagram', 'Facebook', 'WhatsApp', 'Referral', 'Direct Website', 'AI Visualizer', 'Emergency Services', 'Contact Form', 'Other'];

export const fmtMoney = (n) => {
  const num = Number(n) || 0;
  return '$' + num.toLocaleString('en-US', { maximumFractionDigits: 0 });
};

export const timeSince = (iso) => {
  if (!iso) return '';
  const diff = Date.now() - new Date(iso).getTime();
  const h = Math.floor(diff / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  if (h >= 24) return `${Math.floor(h / 24)}d ${h % 24}h`;
  return `${h}h ${m}m`;
};

export const api = {
  get: (path) => fetch(`${API}/api${path}`, { credentials: 'include' }),
  post: (path, body) => fetch(`${API}/api${path}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include', body: JSON.stringify(body) }),
  patch: (path, body) => fetch(`${API}/api${path}`, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, credentials: 'include', body: JSON.stringify(body) }),
  del: (path) => fetch(`${API}/api${path}`, { method: 'DELETE', credentials: 'include' }),
  upload: (path, formData) => fetch(`${API}/api${path}`, { method: 'POST', credentials: 'include', body: formData }),
};
